/**
 * Sponsor catalog for the home-page logo wall.
 * Built-in 2026–2027 sponsors show until Firestore docs replace them.
 * Firestore collection: `sponsors/{sponsorSlug}`.
 */

export const STATIC_SPONSORS = [
  { name: 'OmniSource', website: 'https://www.omnisource.com/', logoUrl: '/images/sponsors/omnisource.png', sortOrder: 1 },
  { name: 'Dynamic Transportation LLC', website: 'https://www.facebook.com/dynamictrans/', logoUrl: '/images/sponsors/dynamic-transportation.png', sortOrder: 2 },
  { name: 'JBTC', website: 'https://www.jbtc.net/', logoUrl: '/images/sponsors/jbtc.png', sortOrder: 3 },
  { name: 'Eastman & Smith', website: 'https://www.eastmansmith.com/', logoUrl: '/images/sponsors/eastman-smith.png', sortOrder: 4 },
  { name: 'Square One Solutions', website: 'https://square1-solutions.com/', logoUrl: '/images/sponsors/square-one-solutions.png', sortOrder: 5 },
  { name: 'Spengler Nathanson PLL, Attorneys At Law', website: 'https://snlaw.com/', logoUrl: '/images/sponsors/spengler-nathanson.png', sortOrder: 6 },
  { name: "Romeo's Pizza", website: 'https://romeospizza.com/', logoUrl: '/images/sponsors/romeos-pizza.png', sortOrder: 7 },
  { name: 'Cox Trucking', website: 'https://www.facebook.com/p/Cox-Trucking-Inc-100063537342178/', logoUrl: '/images/sponsors/cox-trucking.png', sortOrder: 8 },
  { name: 'Wauseon Eye Care', website: 'https://wauseoneyecare.com/', logoUrl: '/images/sponsors/wauseon-eye-care.png', sortOrder: 9 },
  { name: 'E-Pak Manufacturing', website: 'https://www.epakmanufacturing.com/', logoUrl: '/images/sponsors/e-pak-manufacturing.png', sortOrder: 10 },
  { name: 'R&J Trucking', website: 'https://www.facebook.com/p/R-J-Trucking-100063705182751/', logoUrl: '/images/sponsors/rj-trucking.png', sortOrder: 11 },
  { name: 'Bull Moose Retirement Planning', website: 'https://bullmoosewealth.com/', logoUrl: '/images/sponsors/bull-moose.png', sortOrder: 12 },
  { name: 'Shaffran Companies', website: 'https://www.shaffran.com/', logoUrl: '/images/sponsors/shaffran.png', sortOrder: 13 },
  { name: "Hub's Swantucky Pub", website: 'https://hubs-swantucky-pub.wheree.com/', logoUrl: '/images/sponsors/hubs-swantucky-pub.png', sortOrder: 14 },
  { name: 'Inverness Club', website: 'https://invernessclub.com/', logoUrl: '/images/sponsors/inverness-club.png', sortOrder: 15 },
];

export function sponsorSlug(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

export function sortSponsors(list) {
  return [...list].sort((a, b) => {
    const sa = Number(a.sortOrder) || 0;
    const sb = Number(b.sortOrder) || 0;
    if (sa !== sb) return sa - sb;
    return String(a.name || '').localeCompare(String(b.name || ''));
  });
}

/** Empty string when missing or not an http(s) URL. Adds https:// when the protocol is omitted. */
export function normalizeSponsorWebsite(raw) {
  const value = String(raw || '').trim();
  if (!value) return '';
  const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`;
  let url;
  try {
    url = new URL(withProtocol);
  } catch {
    return '';
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return '';
  if (!url.hostname || !url.hostname.includes('.')) return '';
  return url.href;
}

export function normalizeSponsor(raw) {
  const name = String(raw.name || '').trim();
  const slug = String(raw.sponsorSlug || sponsorSlug(name)).trim() || sponsorSlug(name);
  const id = raw.id || slug;
  return {
    id,
    name,
    sponsorSlug: slug,
    website: normalizeSponsorWebsite(raw.website),
    logoUrl: typeof raw.logoUrl === 'string' ? raw.logoUrl : '',
    sortOrder: Number.isFinite(Number(raw.sortOrder)) ? Number(raw.sortOrder) : 0,
    active: raw.active !== false,
  };
}

/** Keep sort order inside the range Firestore rules accept. */
function clampSortOrder(value) {
  const n = Number.isFinite(Number(value)) ? Math.trunc(Number(value)) : 0;
  if (n < 0) return 0;
  if (n > 10000) return 10000;
  return n;
}


export function staticSponsorsAsDocs() {
  return sortSponsors(
    STATIC_SPONSORS.map((s) =>
      normalizeSponsor({
        ...s,
        sponsorSlug: sponsorSlug(s.name),
        active: true,
      })
    )
  );
}

export function sponsorWritePayload(fields, { existingSlug } = {}) {
  const name = String(fields.name || '').trim();
  const slug = existingSlug || sponsorSlug(name);
  return {
    name,
    sponsorSlug: slug,
    website: normalizeSponsorWebsite(fields.website),
    logoUrl: typeof fields.logoUrl === 'string' ? fields.logoUrl : '',
    sortOrder: clampSortOrder(fields.sortOrder),
    active: fields.active !== false,
  };
}
